import { Box, makeStyles, Typography } from "@material-ui/core";
import * as React from "react";

import { useDevice } from "@/hooks/useDevice";
import theme from "@/theme";

import MaintenanceImage from "@assets/image/errors/maintenance.png";
import NetworkImage from "@assets/image/errors/network_error.png";
import NotFoundImage from "@assets/image/errors/page_not_found.png";

import { CustomButton } from "./Button";
import { PublicHeader } from "./PublicHeader";
import { FullPageError } from "./StatePanels";

const useStyles = makeStyles(() => ({
  code: { fontSize: 12, marginTop: 24, color: theme.palette.text.secondary, [theme.breakpoints.up("md")]: { fontSize: 14 } },
}));

export type LoadFailure = "network" | "maintenance";

export const AppLoadError: React.FC<{ kind: LoadFailure | "notFound"; onHome?: () => void }> = ({ kind, onHome }) => {
  const classes = useStyles();
  const maintenance = kind === "maintenance";
  const notFound = kind === "notFound";
  const { isMobile } = useDevice();
  const content = (
    <FullPageError
      publicLayout
      title={notFound ? "ページが見つかりません" : maintenance ? "ただいまメンテナンス中です" : "通信できませんでした"}
      description={
        <>
          {notFound ? (
            <>
              リンク先がなくなったか、
              <br />
              変更された可能性があります。
            </>
          ) : maintenance ? (
            "システムメンテナンスを行っています。"
          ) : (
            <>
              通信状況を確認して、
              <br />
              もう一度お試しください。
            </>
          )}
          {notFound && (
            <Typography className={classes.code}>
              エラーコード <span style={{ fontFamily: "Inter, \"Noto Sans JP\", sans-serif" }}>404</span>
            </Typography>
          )}
        </>
      }
      illustration={
        <img
          src={notFound ? NotFoundImage : maintenance ? MaintenanceImage : NetworkImage}
          width="160"
          height="160"
          style={{ objectFit: "contain" }}
          alt=""
        />
      }
      action={
        <CustomButton buttonSize="L" fullWidth onClick={notFound ? onHome : () => window.location.reload()}>
          {notFound ? "ホームへ戻る" : "再読み込み"}
        </CustomButton>
      }
    />
  );
  return isMobile ? content : <Box style={{ minHeight: "100vh", backgroundColor: theme.palette.semantic["surface/base"] }}><PublicHeader />{content}</Box>;
};
